// Imports => Constants
import { ENDPOINTS } from '@constants';

export class ProfileAPI {
  constructor(Client, NoBaseClient, config) {
    this.Client = Client;
    this.NoBaseClient = NoBaseClient;
    this.config = config;
  }

  list = (data) => {
    return this.Client.get(`${ENDPOINTS.PROFILE.LIST}`).then(
      (response) => response.data.data
    );
  };

  list_profiles = (params) => {
    return this.Client.get(`${ENDPOINTS.PROFILE.COLLECTION}`, { params }).then(
      (response) => response.data.data
    );
  };

  who_am_i = (data) => {
    return this.NoBaseClient.get(
      `${this.config.pkce.accounts_uri}${ENDPOINTS.PROFILE.WHOAMI}`
    ).then((response) => response.data.data);
  };

  update = (data) => {
    return this.NoBaseClient.put(
      `${this.config.pkce.accounts_uri}${ENDPOINTS.PROFILE.UPDATE}`,
      data
    ).then((response) => response.data.data);
  };
}

export default ProfileAPI;
